import { render, staticRenderFns } from "./cElementNotices.vue?vue&type=template&id=8c0e7ac8&scoped=true&"
import script from "./cElementNotices.vue?vue&type=script&lang=js&"
export * from "./cElementNotices.vue?vue&type=script&lang=js&"
import style0 from "./cElementNotices.vue?vue&type=style&index=0&id=8c0e7ac8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c0e7ac8",
  null
  
)

export default component.exports